export const POI_DETAILS = `query getPoiDetails($poiId:Int!) {
    getPoiDetails(poiId: $poiId) {
        id
        name
        address
        city
        state
        zip
        status
        latitude
        longitude
    }

}`
